module.exports = __webpack_public_path__ + "media/src/application/media/honest-76997c70a259bcf0b9818623c64274a2.png";